export default {
  title: 'Prvi partner za upravljanje poslovnih nepremičnin.'
}